import React, { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { searchPlanSubscriptionReceptHistoryList } from '@store/actions/appListAction';
import { useDispatch, useSelector } from 'react-redux';

import { getDateByformat, parseDateString } from '@common/utils/date';

const SCROLL_TABLE_WRAP_ID = 'ReceptProcessingHistoryWrap';

const ReceptProcessingHistoryPopup = props => {
  const { policyNo } = props;
  const location = useLocation();
  const { planReceptHistoryList } = useSelector(
    state =>
      // location.pathname === 'appView' // hanjy: appList, appView 구분하지 않고 appList 기본으로 동작
      //   ? state.appViewReducer
      //   : state.appListReducer,
      state.appListReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    handlerSearchList(policyNo);
  }, [policyNo]);

  //리스트 조회
  const handlerSearchList = useCallback(policyNo => {
    const searchPlanSubscriptionReceptHistoryListCallback = () => {
      moveScrollBottom();
    };
    dispatch(
      searchPlanSubscriptionReceptHistoryList({
        policyNo: policyNo,
        callback: searchPlanSubscriptionReceptHistoryListCallback,
      }),
    );
  }, []);

  // scroll 하단 이동
  const moveScrollBottom = () => {
    const scrollWrapElement = document.getElementById(SCROLL_TABLE_WRAP_ID);
    scrollWrapElement.scrollTop = scrollWrapElement.scrollHeight;
  };
  return (
    <>
      <header className="modal-header">
        <h3 className="layer-tit2">접수 중 처리 이력</h3>
      </header>

      <div className="cont">
        <div className="modal-scroll-wrap" id={SCROLL_TABLE_WRAP_ID}>
          <table className="tbl-sty1 list-type">
            <colgroup>
              <col width="22%" />
              <col width="78%" />
            </colgroup>
            <thead>
              <tr>
                <th>처리 일자</th>
                <th>처리 구분</th>
              </tr>
            </thead>
            <tbody>
              {planReceptHistoryList.length > 0 ? (
                planReceptHistoryList
                  .sort((a, b) => {
                    const before = getDateByformat(
                      a.processDate,
                      'yyyyMMddHHmmss',
                    );
                    const after = getDateByformat(
                      b.processDate,
                      'yyyyMMddHHmmss',
                    );
                    return after - before;
                  })
                  .map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span className="f-12 bold">
                            {getDateByformat(item.processDate)}
                          </span>
                        </td>
                        <td className="text-left">
                          {item.processDescription || ''}
                          {item.msg && (
                            <p className="f-12 mgt-5">
                              <span className="c-blue mgr-5">메모</span>
                              {item.msg}
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td colSpan={4} className="nodata">
                    {'검색된 결과가 없습니다.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ReceptProcessingHistoryPopup;
